// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"315787c3","247":"7f9d64db","314":"f41736f5","513":"030ceaf8","706":"cc727622"}[chunkId] + ".chunk.js";
};